import { SupportAgentWidget } from '../../components/shared/SupportAgentWidget';

/** Full-page live support — same WebSocket flow as the floating agent widget. */
export default function SupportChatPage() {
  return (
    <div className="-m-6 lg:-m-8 flex w-full min-w-0 flex-col gap-3 h-[calc(100dvh-4rem)] min-h-[28rem] p-4 sm:p-5 lg:p-6">
      <div className="shrink-0">
        <p className="text-sm text-[hsl(var(--muted-foreground))] mb-1">Support</p>
        <h1 className="text-2xl font-bold text-[hsl(var(--foreground))]">Customer Support Chat</h1>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">
          Live chats from customer and vendor portals appear here in real time.
        </p>
      </div>
      <div className="min-h-0 flex-1">
        <SupportAgentWidget embedded />
      </div>
    </div>
  );
}
